/**
 * Input Schema of CentroDeCusto
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {CargaCollection} from '@/model/collection/CargaCollection'

/* TODO: review generated schema */
export class InputCentroDeCustoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()
  collectionCarga = new CargaCollection().noPagination()

  readonly name = 'InputCentroDeCusto'

  readonly fieldSet: FieldSet<CentroDeCusto> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    cargaCentroDeCusto: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 45,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
